// Card "Pericolosità" per l'Erosione calcolata con l'algoritmo L3
// (`calculateErosioneCdaL3`), condivisa da due schermate diverse con la
// stessa identica shape dati
// (apps/api/docs/box-erosione-l3-campi-da-mostrare.md,
// apps/api/docs/cda-idraulica-mista-l2-l3.md):
// - `L3/Accordion5CdaL3.jsx` — tab "5. CdA Idraulica" di un'attività L3,
//   `erosionCda.danger` quando `erosionCda.calcMethod === 'L3'`;
// - `TabsL2/TabsL2.jsx` — tab Idraulica di un'attività L0,1,2 con lo switch
//   "Tipologia di calcolo" attivo su Erosione, `erosionCdaL3.danger`.
//
// Il BE manda 11 chiavi in `danger`, ma la lista cliente conferma SOLO 5
// campi, in quest'ordine: 164, 171, 612, 172, 592 (aggiornamento 2026-09-01 —
// rimosso 159 "Profondità fondazione rispetto all'alveo", presente nella
// lista precedente del 2026-08-31 ma non richiesto da questa versione). Gli
// altri sei (158/589/590/591, addendi e numeratore della frazione 592, 159
// stesso e 159b il flag Effettivo/Presunto) restano nel payload ma sono
// deliberatamente FUORI da questa card — non vanno mostrati finché il
// cliente non li richiede esplicitamente. Valori già stringhe leggibili dal
// BE (es. "Profonde") — niente traduzione enum→label lato client. Ca/Cg NON
// compaiono qui: non sono input di calculateErosioneCdaL3, restano un
// placeholder solo nel ramo L2 generalizzata (matrice tradizionale).
export const erosioneL3DangerFields = danger => {
  // "Estensione della protezione al piede" (612) e "Stato di conservazione e
  // adeguatezza opera" (172) sono attivabili solo se "Protezione al piede
  // delle pile e delle spalle" (171) = Sì (Accordion4ErosionL3.jsx,
  // watchProtezioneAlPiedePileSpalleSi — stessa condizione qui, sulla
  // stringa già tradotta dal BE). Se No, i due campi sono legittimamente
  // vuoti: vanno del tutto omessi da `values`, non passati con `value`
  // falsy, altrimenti CardL2 li marca in rosso "Dati non sufficienti per il
  // calcolo" (CardL2.jsx, renderCustomTextfield) per un'assenza attesa, non
  // un dato mancante.
  const protezioneAttiva = danger?.protezioneAlPiedePileSpalle === 'Sì';

  return [
    {
      label: 'Evidenze sulla profondità delle fondazioni',
      value: danger?.evidenzeProfonditaDelleFondazioni, // 164
    },
    {
      label: 'Protezione al piede delle pile e delle spalle del ponte',
      value: danger?.protezioneAlPiedePileSpalle, // 171
    },
    ...(protezioneAttiva
      ? [
          {
            label: 'Estensione della protezione al piede',
            value: danger?.estensioneProtezioneAlPiede, // 612
          },
          {
            label: 'Stato di conservazione e adeguatezza opera',
            value: danger?.statoConservazioneProtezionePiede, // 172
          },
        ]
      : []),
    {
      label: 'Rapporto ds,tot/df',
      value: danger?.rapportoDsTotDf, // 592
    },
  ];
};
